import { render, staticRenderFns } from "./PersonalIdForm.vue?vue&type=template&id=54bf8965&scoped=true&"
import script from "./PersonalIdForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalIdForm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalIdForm.vue?vue&type=style&index=0&id=54bf8965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf8965",
  null
  
)

export default component.exports